import { useMemo } from "react";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import {
  INTEGRATION_PROVIDER_NAME_TO_TYPE,
  staticConnectionProviderNames,
} from "@src/constants/integration-provider.model";

import "./provider.dropdown.scss";

export function ProviderDropdown({
  className,
  onProviderSelected,
  selectedProvider,
}) {
  const values = useMemo(() => {
    return staticConnectionProviderNames.map((provider) => ({
      typeId: INTEGRATION_PROVIDER_NAME_TO_TYPE[provider],
      name: provider,
    }));
  }, []);

  return (
    <Dropdown
      className={`provider-dropdown ${className}`}
      selected={selectedProvider}
      onOptionSelected={onProviderSelected}
    >
      <DropdownButton placeholder="All Providers" clearEnabled>
        {selectedProvider?.name}
      </DropdownButton>
      <DropdownItems>
        {values.map((value) => (
          <DropdownItem key={value.name} value={value}>
            {value.name}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
}
